// services/api.ts
import axios, {
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios';
import { getCurrentCompanyConfig } from '../config/companies';

const api = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

// Extend config type to include our custom noAuth flag
interface CustomAxiosConfig extends InternalAxiosRequestConfig {
  noAuth?: boolean;
}

api.interceptors.request.use(
  (config: CustomAxiosConfig): InternalAxiosRequestConfig => {
    const companyConfig = getCurrentCompanyConfig();
    config.baseURL = companyConfig?.apiUrl || import.meta.env.VITE_API_URL;

    console.log("request config from axios instance", config);
    console.log("company config from axiosInstance", companyConfig);
    console.log("api url from env", import.meta.env.VITE_API_URL);

    if (!config.noAuth) {
      const token = localStorage.getItem('Token');
      if (token) {
        if (config.headers && typeof config.headers.set === 'function') {
          config.headers.set('Authorization', `Bearer ${token}`);
        }
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;















// import axios from "axios";

// const axiosInstance = axios.create({
//   headers: { "Content-Type": "application/json" },
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const url = config.url || "";
//     const isTokenEndpoint = url.includes("getAccessToken");

//     if (!isTokenEndpoint) {
//       const bearerToken = localStorage.getItem("bearerToken");
//       if (bearerToken) {
//         config.headers.Authorization = `Bearer ${bearerToken}`;
//       }
//     }

//     const customAuth = localStorage.getItem("customAuth");
//     const needsCustomAuth =
//       url.includes("ects-einvoicing/v1/verifyenduser") || url.includes("ects-einvoicing/v1/crregupdate");
//     if (customAuth && needsCustomAuth) {
//       config.headers["X-Custom-Auth"] = customAuth;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const status = error?.response?.status;

//     if (status === 401 || status === 403) {
//       localStorage.removeItem("bearerToken");
//       localStorage.removeItem("customAuth");

//     //   if (window.location.pathname !== "/session-timeout") {
//     //     window.location.href = "/session-timeout";
//     //   }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

